import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import * as curriculumDataActions from '../../actions/curriculumData';


const mapStateToProps = state => ({
  cathedrasList: state.curriculumData.cathedrasList,
  coursesList: state.curriculumData.coursesList,
});

const mapDispatchToProps = dispatch => ({
  getCathedras: () => dispatch(curriculumDataActions.getTeacherCathedras()),
  getCourses: () => dispatch(curriculumDataActions.getCurriculumCourses()),
});

const CreateNewForm = ({ modalHandler, submitHandler, getCathedras, getCourses, coursesList }) => {
  const [formValues, setFormValues] = useState({});

  const onChange = (event) => {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmit = (event) => {
    event.preventDefault();
    submitHandler(formValues);
  };

  useEffect(() => {
    getCathedras()
      .catch((err) => {
        console.log(err);
      });
    getCourses()
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <form className="smallModalForm" onSubmit={onSubmit}>
      <div className="caption">Создание нового документа</div>
      <Row>
        <Col md={12}>
          <label className="smallInputLabel">Учебная программа</label>
          <select name="curriculum_course_id" defaultValue={''} onChange={onChange}>
            <option value="" disabled>Выберите...</option>
            {coursesList && coursesList.map((item, index) => (<option key={index} value={item.cid}>{item.course}</option>))}
          </select>
        </Col>
      </Row>
      <Row className="justify-content-end mt-2">
        <Col md={'auto'}>
          <button type="button" className="btn btn-empty mr-3" onClick={() => modalHandler(false)}>Отмена</button>
          <button type="submit" className="btn" disabled={!formValues.curriculum_course_id}>Сохранить</button>
        </Col>
      </Row>
    </form>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewForm);